var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-row-start-start gap-2 w-100 direction-ltr"},[_c('div',{staticClass:"bullet",class:{ selected: _vm.selected }},[_c('div')]),_c('div',{staticClass:"radio-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }